import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL, // Flask backend URL
    headers: { 'Content-Type': 'application/json' },
});

// Interceptor to handle 401 errors
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token'); // Remove token
            // Handle 401 error (e.g., redirect to login or show a message)
            alert('Unauthorized access. Please log in again.');
            // Optionally, you can redirect to the login page or perform other actions
            window.location.href = '/'; // Redirect to home or login page
        }
        return Promise.reject(error);
    }
);

export const registerUser = (userData) => api.post('/register', userData);
export const loginUser = (userData) => api.post('/login', userData);
export const getProtectedData = (token) =>
    api.get('/protected', { headers: { Authorization: `Bearer ${token}` } });

export const createTicket = (token, ticketData) => {
    api.post('/tickets', ticketData, { headers: { Authorization: `Bearer ${token}` } });
}

export const getUserTickets = (token) =>
    api.get('/tickets/user', { headers: { Authorization: `Bearer ${token}` } });

export const getPublicTickets = () => api.get('/tickets/public');

// Fetch ticket by ID
export const getTicketById = (token, ticketId) =>
    api.get(`/tickets/${ticketId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });

// Update ticket
export const updateTicket = (token, ticketId, ticketData) =>
    api.put(`/tickets/${ticketId}`, ticketData, {
        headers: { Authorization: `Bearer ${token}` },
    });

// Fetch metrics
export const getMetrics = () => api.get('/metrics');
// src/api.js
export const getCategoryMetrics = () => api.get('/metrics/categories');

export const uploadImage = (token, formData) =>
    api.post('/upload', formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });

export default api;